import {
  addToFavorites,
  getFavorites,
  removeFavorite,
} from "@/lib/api/favorite";
import { useAuth } from "@clerk/nextjs";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useLocale } from "next-intl";

export const FAVORITES_QUERY_KEY = "favorites";

export const useFavorites = ({
  page,
  size,
}: {
  page: number;
  size: number;
}) => {
  const { getToken } = useAuth();
  const locale = useLocale();

  return useQuery({
    queryKey: [FAVORITES_QUERY_KEY, page, size],
    queryFn: async () => {
      const token = await getToken();

      return getFavorites(token!, page, size, locale);
    },
  });
};

export const useAddToFavorites = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const token = await getToken();
      return addToFavorites(id, token!);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FAVORITES_QUERY_KEY] });
    },
  });
};

export const useRemoveFavorite = () => {
  const queryClient = useQueryClient();
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const token = await getToken();
      return await removeFavorite(id, token!);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FAVORITES_QUERY_KEY] });
    },
  });
};
